<template>
  <div class="view-step">
    <!-- 配件 -->
    <div v-if="isBom" class="step-item">
      <div class="step-circle">
        <span class="step-icon iconfont icon-right"></span>
      </div>
      <div class="step-name" :title="data.tableBomData.map((item) => item.name).join('、')">
        配件(<span class="f-bold c-yellow">{{ bomLen }}件</span>)
      </div>
      <div class="step-type">{{ tableDataList.length }}/{{ tableDataList.length }}</div>
      <div class="step-price">¥{{ bomPrice }}</div>
      <div class="step-line"></div>
    </div>
    <!-- 零件/原材料 -->
    <div v-else class="step-item">
      <div class="step-circle">
        <span class="step-icon iconfont icon-right"></span>
      </div>
      <div class="step-name">
        {{ data.table_data_2.length ? '零件' : '原材料' }}({{ data.table_data_1[0].name || '空' }})
      </div>
      <div class="step-type">{{ tableDataList.length }}/{{ tableDataList.length }}</div>
      <div class="step-price">
        ¥{{
          data.table_data_2.length
            ? data.table_data_2[0].goods_price || 0
            : data.table_data_1[0].goods_price || 0
        }}
      </div>
      <div class="step-line"></div>
    </div>
    <!-- 工艺/费用 -->
    <div
      :class="{
        'step-item': true,
        'is-gongyi': item.item_type === '工艺',
        'is-feiyong': item.item_type === '费用'
      }"
      v-for="(item, index) in tableDataList"
      :key="index"
    >
      <div class="step-circle">
        <span class="step-icon iconfont icon-right"></span>
      </div>
      <div class="step-name">{{ item.name || '空' }}</div>
      <div class="step-type">{{ item.item_type }}{{ item.item_index }}</div>
      <div class="step-price">¥{{ item.item_price }}</div>
      <div class="step-line"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    effectCount() {
      let result = 0
      let effectList = this.data.tableBomData.filter((item) => {
        return item.name
      })
      result = effectList.length
      return result
    },
    isBom() {
      let result = !!this.data.tableBomData.length
      return result
    },
    bomLen() {
      let result = this.data.tableBomData.length
      return result
    },
    bomPrice() {
      let result = this.data.tableBomData.reduce((pre, cur) => pre + cur.goods_price, 0)
      result = result || 0
      return result
    },
    tableDataList() {
      let result = []
      this.data.table_data_3.forEach((item, index) => {
        let obj = this.$util.deepCopy(item)
        obj.item_type = '工艺'
        obj.item_index = index + 1
        obj.item_price = item.goods_price || 0
        result.push(obj)
      })
      this.data.table_data_4.forEach((item, index) => {
        let obj = this.$util.deepCopy(item)
        obj.item_type = '费用'
        obj.item_index = index + 1
        obj.item_price = this.$XEUtils.divide(item.goods_amount, this.data.counts)
        result.push(obj)
      })
      return result
    }
  }
}
</script>

<style lang="less" scoped>
.view-step {
  display: flex;
  flex-wrap: wrap;
  margin-left: 10px;
  line-height: 14px;
  .step-item {
    display: flex;
    flex-direction: column;
    position: relative;
    min-width: 40px;
    text-align: center;
    & ~ .step-item {
      padding-left: 15px;
    }
    &:first-child {
      .step-line {
        left: 50%;
      }
    }
    &:last-child {
      .step-line {
        right: 50%;
      }
    }
    &.is-gongyi {
      .step-name {
        background: @colorBlue;
        border-color: @colorBlue;
      }
      .step-circle {
        background: @colorBlue;
        border-color: #bbdcff;
      }
      .step-line {
        border-color: @colorBlue;
      }
    }
    &.is-feiyong {
      .step-name {
        background: @colorGreen;
        border-color: @colorGreen;
      }
      .step-circle {
        background: @colorGreen;
        border-color: #7dffc4;
      }
      .step-line {
        border-color: @colorGreen;
      }
    }
    .step-circle {
      display: none;
      position: relative;
      margin: 0 auto;
      width: 10px;
      height: 10px;
      text-align: center;
      line-height: 10px;
      background: @colorOrange;
      border: 2px solid #ffc9b7;
      border-radius: 7px;
      z-index: 1;
      .step-icon {
        font-size: 8px;
        color: @colorWhite;
      }
    }
    .step-line {
      border-top: 1px dashed @colorOrange;
      position: absolute;
      top: 11px;
      left: 0;
      right: 0;
    }
    .step-name {
      position: relative;
      margin-top: 2px;
      padding: 2px 5px;
      color: @colorWhite;
      background: @colorOrange;
      border: @border;
      border-color: @colorOrange;
      border-radius: 10px;
      z-index: 1;
    }
    .step-type {
      margin-top: 2px;
      color: @colorGray;
    }
    .step-price {
      margin-top: 2px;
      color: @colorRed;
    }
  }
}
</style>
